import Badge from "hardcover-ui/components/Badge";
import Icon from "hardcover-ui/components/Icon";
import { BadgeThemeProps } from "hardcover-ui/theme/components/badge";
import sparkles from "icons/solid/sparkles.svg";

interface BookMatchPercentageForUser {
  matchScore?: number;
  size?: BadgeThemeProps["size"];
}

export default function MatchPercentageBadge({
  size = "sm",
  matchScore,
}: BookMatchPercentageForUser) {
  if (!matchScore) {
    return false;
  }

  return (
    <Badge variant="accent" size={size} className="space-x-1 inline">
      <Icon icon={sparkles} size="sm" />
      <span>{matchScore}%</span>
    </Badge>
  );
}
